import React from 'react'
import { Row, Col } from "antd"
import { useMediaQuery } from "react-responsive"
import HowItWorksItem from './components/HowItWorksItem'
import connectImg from "images/shippy/points/connect.svg"
import syncImg from "images/shippy/points/sync.svg"
import generateImg from "images/shippy/points/generate.svg"
import deliverImg from "images/shippy/points/deliver.svg"


const HowItWorksSection = () => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  const dataItems = [
    {
      image: connectImg,
      description: "Parsisiunčiamas Alsendo įskiepis į tavo paskyrą OpenCart sistemoje"
    },
    {
      image: syncImg,
      description: "Sudiegiami nustatymai pagal Alsendo parengtą instrukciją"
    },
    {
      image: generateImg,
      description: "Užsakymų valdymas vyksta tavo OpenCart aplinkoje"
    },
    {
      image: deliverImg,
      description: "Lipdukų generavimas, kurjerių iškvietimas ir užsakymų valdymas vyksta tavo OpenCart aplinkoje"
    }
  ];

  return (
    <>
      <Row
        gutter={{ lg: 16 }}
        align="middle"
        style={{
          marginTop: isMobileScreen ? "10px" : "-90px",
          textAlign: isMobileScreen ? "left" : "center"
        }}
      >
        <Col
          span={24}
          style={{
            marginBottom: "15px"
          }}
        >
          <div className="section-title about-title" style={{
            marginTop: isMobileScreen ? "" : "50px",
            marginBottom: isMobileScreen ? "" : "15px",
            paddingLeft: isMobileScreen ? "15px" : "",
            paddingRight: isMobileScreen ? "15px" : "",
            textAlign: "center"
          }}>
            {"Kaip tai veikia?"}
          </div>
        </Col>

        <div
          style={
            {
              display: "flex",
              justifyContent: "center",
              width: "100%",
              padding: isMobileScreen ? "15px 15px" : "",
              marginBottom: isMobileScreen ? "" : "50px"
            }
          }
        >
          <Row gutter={[32, 10]} style={{ maxWidth: 1200 }}>
            {
              dataItems.map((item) => {
                return (
                  <HowItWorksItem dataItem={item} />
                )
              })
            }
          </Row>
        </div>
      </Row>
    </>
  )
}

export default HowItWorksSection
